import BaseService from './base';

class DuelService extends BaseService {
  constructor() {
    super();
    const base = this.constructor.init();
    this.$http = base.$http;
  }

  async assignTo(id) {
    const result = await this.post(`/duel/assign/${id}`);
    return result;
  }

  async unassignFrom(id) {
    const result = await this.delete(`/duel/unassign/${id}`);
    return result;
  }

  async getDuels(gameId, isCompleted) {
    let path = `/duel/find/game/${gameId}`;
    if (isCompleted) path += `?filterBy=user`;
    const result = await this.get(path);
    return result;
  }

  async getDuel(id) {
    const result = await this.get(`/duel/find/${id}`);
    return result;
  }

  async getPredictionsTypes() {
    const result = await this.get('/duel/predictions/types');
    return result;
  }

  async calcDuelStandings(id) {
    const result = await this.get(`/duel/standings/calculate/${id}`);
    return result;
  }
}

export default new DuelService();
